// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Mint from 'mint-ui'
import router from './router'
import store from './store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import api from './request/api' // 导入api接口
import VueCookies from 'vue-cookies'
import util from './util/util.js'//引入公共JS
import './assets/iconfont/iconfont.css'//引入公共JS
import FastClick from 'fastclick'


import { PullRefresh } from "vant"; Vue.use(PullRefresh);
import { List } from 'vant'; Vue.use(List);
import { Collapse, CollapseItem } from 'vant'; Vue.use(Collapse); Vue.use(CollapseItem);
import { Tab, Tabs } from 'vant'; Vue.use(Tab); Vue.use(Tabs);
import { Field } from 'vant'; Vue.use(Field);
import { Button } from 'vant'; Vue.use(Button);
import { Cell,CellGroup } from 'vant'; Vue.use(Cell);Vue.use(CellGroup);
import { Popup } from 'vant'; Vue.use(Popup);
import { Swipe, SwipeItem } from 'vant'; Vue.use(Swipe); Vue.use(SwipeItem);
import { ImagePreview } from 'vant';Vue.use(ImagePreview);
import { Tag } from 'vant';Vue.use(Tag);
import { Overlay } from 'vant';Vue.use(Overlay);
import { RadioGroup, Radio } from 'vant';Vue.use(RadioGroup);Vue.use(Radio);
import { Checkbox, CheckboxGroup } from 'vant';Vue.use(Checkbox);Vue.use(CheckboxGroup);
import { DatetimePicker} from 'vant';Vue.use(DatetimePicker);
import { Dialog } from 'vant';Vue.use(Dialog);
import { Loading } from 'vant';Vue.use(Loading);
import { Popover } from 'vant';Vue.use(Popover);
import { Sticky } from 'vant';Vue.use(Sticky);
import { Switch } from 'vant';Vue.use(Switch);
import { CountDown  } from 'vant';Vue.use(CountDown );
import { NoticeBar } from 'vant';Vue.use(NoticeBar);
import { Picker  } from 'vant';Vue.use(Picker );
import 'vant/lib/image-preview/style';
import "vant/lib/pull-refresh/style";
import 'vant/lib/list/style';
import 'vant/lib/collapse/style';
import 'vant/lib/collapse-item/style';
import 'vant/lib/tabs/style';
import 'vant/lib/tab/style';
import 'vant/lib/button/style';
import 'vant/lib/field/style';
import 'vant/lib/cell/style';
import 'vant/lib/popup/style';
import 'vant/lib/swipe/style';
import 'vant/lib/swipe-item/style';
import 'vant/lib/radio-group/style';
import 'vant/lib/radio/style';
import 'vant/lib/checkbox/style';
import 'vant/lib/checkbox-group/style';
import 'vant/lib/cell-group/style';
import 'vant/lib/datetime-picker/style';
import 'vant/lib/dialog/style';
import 'vant/lib/loading/style';
import 'vant/lib/popover/style';
import 'vant/lib/sticky/style';
import 'vant/lib/switch/style';
import 'vant/lib/count-down/style';
import 'vant/lib/notice-bar/style';
import 'vant/lib/picker/style';
// import vueEsign from 'vue-esign'


import 'mint-ui/lib/style.css'

Vue.use(Mint);
Vue.use(VueAwesomeSwiper);
Vue.use(VueCookies)
Vue.prototype.$api = api; // 将api挂载到vue的原型上
Vue.prototype.util = util;

Vue.config.productionTip = false

FastClick.attach(document.body);
FastClick.prototype.focus = function(targetElement) {
  var length;
  //兼容处理:在iOS7中，有一些元素（如date、datetime、month等）在setSelectionRange会出现TypeError
  //这是因为这些元素并没有selectionStart和selectionEnd的整型数字属性，所以一旦引用就会报错，因此排除这些属性才使用setSelectionRange方法
  if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month' && targetElement.type !== 'email') {
      length = targetElement.value.length;
      targetElement.setSelectionRange(length, length);
      /*修复bug ios 11.3不弹出键盘，这里加上聚焦代码，让其强制聚焦弹出键盘*/
      targetElement.focus();
  } else {
      targetElement.focus();
  }
};
/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})
export default vue




// WEBPACK FOOTER //
// ./src/main.js